import PawModel from './PawModel';

class Folder extends PawModel {
  static apiType = 'folders';

  static d3Compatible = false;

  user_id!: string;

  title!: string;
  
  mode!: string;
  
  values: any;

  parent_id!: string;
  
  level!: number;
  
  path!: string[];
}

export default Folder;